import { combineReducers } from '@reduxjs/toolkit';
import authReducer from './auth';
import usersReducer from './users';
import historyReducer from './history/slices/index';

const reducer = combineReducers({
  auth: authReducer,
  history: historyReducer,
  users: usersReducer,
});

/**
 * @description
 * Check if state should be cleared if logout action was or another similar action was dispatched.
 *
 * @param {Object} [state] State generated by the store reducer
 * @param {Object} [action] Dispatched action to be checked
 *
 * @return {Function} Final checked state
 */

const rootReducer = (state, action) => {
  if (action.type === 'user/clearState') {
    return reducer({}, action);
  }

  return reducer(state, action);
};

export default rootReducer;
